import React, { SyntheticEvent } from 'react';
import ButtonSave from './ButtonSave';
import ButtonCancel from './ButtonCancel';

interface PropType {
    validate: () => boolean;
    onCancel: (e: SyntheticEvent) => void;
}

class FormFooter extends React.Component<PropType> {
    public render() {
        return (
            <div className="form-group">
                <div className="col-sm-1">
                    <ButtonCancel onClick={this.props.onCancel} />
                </div>
                <div className="col-sm-1 pull-right">
                    <ButtonSave disabled={!this.props.validate()} className="pull-right" type="submit" />
                </div>
            </div>
        );
    }
}

export default FormFooter;



// WEBPACK FOOTER //
// ./src/components/Form/FormFooter.tsx